import React from "react";
import { UserRound } from "lucide-react";

const sizes = {
  xs: "w-6 h-6",
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-14 h-14",
};
const iconSizes = { xs: "w-3.5 h-3.5", sm: "w-4 h-4", md: "w-5 h-5", lg: "w-7 h-7" };

// Silhouette placeholder avatar for the responsible person of a zona/empresa.
// `src` (optional) shows a real photo when available; otherwise a neutral silhouette.
export function PersonAvatar({ name, src, size = "sm", className = "" }) {
  const vacant = !name || /vacante|sin asignar/i.test(name);
  return (
    <div
      title={name || "Sin asignar"}
      className={`${sizes[size]} rounded-full overflow-hidden flex items-center justify-center shrink-0 ring-1 ring-slate-200 ${
        vacant ? "bg-slate-100" : "bg-gradient-to-br from-slate-200 to-slate-300"
      } ${className}`}
      data-testid="person-avatar"
    >
      {src ? (
        <img src={src} alt={name} className="w-full h-full object-cover" />
      ) : (
        <UserRound className={`${iconSizes[size]} ${vacant ? "text-slate-300" : "text-slate-500"}`} strokeWidth={1.8} />
      )}
    </div>
  );
}
